<template>
    <div class="box">
        <div class="top">
            <img :src="'data:image/png;base64,' + base" alt="">
        </div>  
        <div class="content">
            <div v-html="news"></div> 
        </div> 
    </div>
     
</template>


<script>
export default {
    data() {
        return {
            news: '',
            base:''
        }
    },
    created() {
        this.news = this.$route.query.news
        this.base = this.$route.query.base
    },
    mounted() {
        document.title = this.$route.query.type
    }
}
</script>

<style scoped lang="scss">
    
    .box {
       display: flex;
             flex-direction: column;
            align-items: center;
        .top {

            img {
                margin-top: 20px;
                width: 690px;
                height: 300px;
                object-fit: cover;
                
            }
           
        }
        .content {
            width: 690px;
             ::v-deep  input{
                margin-right: 5px !important;
            }
            ::v-deep h1 {
                text-align: center;
            }
            ::v-deep h2 {
                text-align: center;
            }
            ::v-deep h3, {
                text-align: center;
            }
            ::v-deep h4 {
                text-align: center;
            }
            ::v-deep h5 {
                text-align: center;
            }
        }     
    }
</style>